import { render, staticRenderFns } from "./systemConfig.vue?vue&type=template&id=d6be856a&scoped=true&"
import script from "./systemConfig.vue?vue&type=script&lang=js&"
export * from "./systemConfig.vue?vue&type=script&lang=js&"
import style0 from "./systemConfig.vue?vue&type=style&index=0&id=d6be856a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6be856a",
  null
  
)

export default component.exports